import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class BusinessStructure extends Enum {
  key!: string;
  value!: string;

  static CORPORATION: BusinessStructure = {
    key: 'corporation',
    get value(): string {
      return Lang.t('asset.corporation');
    }
  };

  static SOLE_PROPRIETORSHIP: BusinessStructure = {
    key: 'sole_proprietorship',
    get value(): string {
      return Lang.t('asset.sole-proprietorship');
    }
  };

  static PARTNERSHIP: BusinessStructure = {
    key: 'partnership',
    get value(): string {
      return Lang.t('asset.partnership');
    }
  };
}
